import { backendBaseUrl } from "src/domains/shared/api/calculation/backendBaseUrl";
import { uploadInChunks } from "src/domains/projects-list/api/chunkedUpload/uploadInChunks";

export interface UploadDwgParams {
  /** 업로드 파일명 `{이름}.dwg` — stem 이 도면 식별자, 동명 재업로드는 교체. NFD 정규화는 호출 측 책임. */
  fileName: string;
  /** dwg 원본 바이너리. */
  file: File;
}

export interface UploadDwgResponse {
  /** 적재된 dwg 파일명(basename + NFD 정규화). */
  name: string;
}

/**
 * 512KB 고정 청크 순차 업로드(`uploadInChunks` 공용 헬퍼 위임) — 마지막 청크(last=true) 응답의
 * `name` 수신으로 완료를 판별해 반환한다. 경로는 신 경로 `/dwg/uploads` — deprecated
 * 구 경로(`/dwg-uploads`)를 쓰지 않는다.
 */
export async function uploadDwg(
  projectId: number,
  { fileName, file }: UploadDwgParams
): Promise<UploadDwgResponse> {
  const name = await uploadInChunks<string>({
    url: `${backendBaseUrl()}/projects/${projectId}/drawing-meshes/dwg/uploads`,
    fileName,
    file,
    pickCompletion: (data) => data.name as string | undefined,
    label: "dwg 업로드",
  });
  return { name };
}
